import React from "react";
import MenuItemElement from "../DashBoard/DashboardMenu/MenuItemElement";
import { NotifcationsMenuItem } from "../DashBoard/DashboardMenu/DashboardMenuItems";

function ButtonsContainer() {
  return (
    <div className="w-100 px-3">
      <MenuItemElement title={""} menuItems={NotifcationsMenuItem.items} />
    </div>
  );
}

export default ButtonsContainer;
